module.exports = __webpack_public_path__ + "static/media/about.fd7b2019.webp";